import React from 'react';
import { LandingComponent } from 'app/types';
import { TitlePreview } from './TitlePreview';
interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}
const HeroBannerPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const titleCol = landing_cmp.config.style === 'homepage' ? 'col-lg-7' : 'col-lg-6';
  const imgCol = landing_cmp.config.style === 'homepage' ? 'col-lg-5' : 'col-lg-6';
  const order =
    landing_cmp.config.style === 'homepage' || landing_cmp.config.style === 'reverse'
      ? 'order-first order-lg-last'
      : '';
  const padding = landing_cmp.config.style === 'homepage' ? 'p-0' : 'p-4';
  const bannerOrder = (alignment?: string) => {
    if (alignment === 'left') return 'order-first';
    else return '';
  };
  return (
    <div className="row">
      <div
        className={`ua-cms__hero-banner-content infoSection col-12 ${titleCol} d-flex flex-column justify-content-center py-5 px-3 px-md-4`}
      >
        <TitlePreview landing_cmp={landing_cmp} isStandalone={false} />
      </div>
      {typeof landing_cmp.image_file === 'string' && (
        <div
          className={`ua_cms__hero-banner-image imageSection col-12 ${imgCol} d-flex align-items-center justify-content-center ${bannerOrder(
            landing_cmp.config.alignment
          )} ${order} ${padding}`}
        >
          <img className="img-fluid" src={landing_cmp.image_file} />
        </div>
      )}
    </div>
  );
};
export default HeroBannerPreview;
